export default __webpack_public_path__ + "static/media/secure.45b8caf4.png";